import React from 'react';
import { FaCheck, FaTimes, FaMinus } from 'react-icons/fa';
import './styles.css';

interface BinaryScoreInputProps {
  value: boolean | null;
  onChange: (value: boolean | null) => void;
}

const BinaryScoreInput: React.FC<BinaryScoreInputProps> = ({ value, onChange }) => {
  return (
    <div className="binary-score-input">
      <button
        type="button"
        className={`score-button pass ${value === true ? 'selected' : ''}`}
        onClick={() => onChange(true)}
        title="Pass"
      >
        <FaCheck />
      </button>
      <button
        type="button"
        className={`score-button fail ${value === false ? 'selected' : ''}`}
        onClick={() => onChange(false)}
        title="Fail"
      >
        <FaTimes />
      </button>
      <button
        type="button"
        className={`score-button not-evaluated ${value === null ? 'selected' : ''}`}
        onClick={() => onChange(null)}
        title="Not Evaluated"
      >
        <FaMinus />
      </button>
    </div>
  );
}

export default BinaryScoreInput; 